import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Platform, Text, View } from "react-native";

function _assert_this_initialized(self) {
	if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	return self;
}
function _call_super(_this, derived, args) {
	derived = _get_prototype_of(derived);
	return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
	if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}
function _create_class(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	return Constructor;
}
function _define_property(obj, key, value) {
	if (key in obj) Object.defineProperty(obj, key, {
		value,
		enumerable: true,
		configurable: true,
		writable: true
	});
	else obj[key] = value;
	return obj;
}
function _get_prototype_of(o) {
	_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o2) {
		return o2.__proto__ || Object.getPrototypeOf(o2);
	};
	return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
	subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: {
		value: subClass,
		writable: true,
		configurable: true
	} });
	if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
	if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
	else return left instanceof right;
}
function _possible_constructor_return(self, call) {
	if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
	return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
	_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o2, p2) {
		o2.__proto__ = p2;
		return o2;
	};
	return _set_prototype_of(o, p);
}
function _type_of(obj) {
	"@swc/helpers - typeof";
	return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
	try {
		var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch (_) {}
	return (_is_native_reflect_construct = function() {
		return !!result;
	})();
}
var RootErrorBoundary = /* @__PURE__ */ (function(_React_Component) {
	"use strict";
	_inherits(RootErrorBoundary2, _React_Component);
	function RootErrorBoundary2() {
		_class_call_check(this, RootErrorBoundary2);
		var _this = _call_super(this, RootErrorBoundary2, arguments);
		_define_property(_this, "state", {
			hasError: false,
			error: null,
			componentStack: null
		}), _define_property(_this, "handleRetry", function() {
			_this.setState({
				hasError: false,
				error: null,
				componentStack: null
			});
		});
		return _this;
	}
	_create_class(RootErrorBoundary2, [{
		key: "componentDidCatch",
		value: function componentDidCatch(error, info) {
			this.setState({ componentStack: info.componentStack || null });
			console.error(`[One] Root error boundary caught error:
${printError(error)}
${info.componentStack}`);
			if (typeof window !== "undefined" && typeof CustomEvent !== "undefined") window.dispatchEvent(new CustomEvent("one-error", { detail: {
				error: {
					message: error.message,
					stack: error.stack,
					name: error.name
				},
				componentStack: info.componentStack,
				timestamp: Date.now(),
				type: "render"
			} }));
		}
	}, {
		key: "render",
		value: function render() {
			if (this.state.hasError) {
				var { error, componentStack } = this.state;
				var isDev = process.env.NODE_ENV === "development";
				if (Platform.OS === "web") return /* @__PURE__ */ jsx("div", {
					style: {
						minHeight: "100vh",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						backgroundColor: "#0a0a0f",
						fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
						color: "#e8e8e8",
						padding: 24
					},
					children: /* @__PURE__ */ jsxs("div", {
						style: {
							maxWidth: 500,
							width: "100%",
							textAlign: "center"
						},
						children: [
							/* @__PURE__ */ jsx("div", {
								style: {
									width: 64,
									height: 64,
									backgroundColor: "#ef4444",
									borderRadius: "50%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									margin: "0 auto 24px"
								},
								children: /* @__PURE__ */ jsxs("svg", {
									width: "32",
									height: "32",
									viewBox: "0 0 24 24",
									fill: "none",
									stroke: "white",
									strokeWidth: "2",
									children: [
										/* @__PURE__ */ jsx("circle", {
											cx: "12",
											cy: "12",
											r: "10"
										}),
										/* @__PURE__ */ jsx("line", {
											x1: "12",
											y1: "8",
											x2: "12",
											y2: "12"
										}),
										/* @__PURE__ */ jsx("line", {
											x1: "12",
											y1: "16",
											x2: "12.01",
											y2: "16"
										})
									]
								})
							}),
							/* @__PURE__ */ jsx("h1", {
								style: {
									fontSize: 24,
									fontWeight: 600,
									marginBottom: 8
								},
								children: "Something went wrong"
							}),
							/* @__PURE__ */ jsx("p", {
								style: {
									fontSize: 14,
									color: "#888",
									marginBottom: 24
								},
								children: (error === null || error === void 0 ? void 0 : error.message) || "An unexpected error occurred"
							}),
							/* @__PURE__ */ jsxs("div", {
								style: {
									display: "flex",
									gap: 12,
									justifyContent: "center"
								},
								children: [/* @__PURE__ */ jsx("button", {
									onClick: this.handleRetry,
									style: {
										padding: "12px 24px",
										backgroundColor: "#3b82f6",
										color: "white",
										border: "none",
										borderRadius: 8,
										fontSize: 14,
										fontWeight: 500,
										cursor: "pointer"
									},
									children: "Try Again"
								}), /* @__PURE__ */ jsx("button", {
									onClick: function() {
										if (typeof window !== "undefined") window.location.href = "/";
									},
									style: {
										padding: "12px 24px",
										backgroundColor: "transparent",
										color: "#888",
										border: "1px solid #3a3a5a",
										borderRadius: 8,
										fontSize: 14,
										fontWeight: 500,
										cursor: "pointer"
									},
									children: "Go Home"
								})]
							}),
							isDev && /* @__PURE__ */ jsx("p", {
								style: {
									fontSize: 11,
									color: "#666",
									marginTop: 24
								},
								children: "Press Alt+E to view error details"
							})
						]
					})
				});
				return /* @__PURE__ */ jsxs(View, {
					style: {
						flex: 1,
						alignItems: "center",
						justifyContent: "center",
						backgroundColor: "#0a0a0f",
						padding: 24
					},
					children: [
						/* @__PURE__ */ jsx(View, {
							style: {
								width: 64,
								height: 64,
								backgroundColor: "#ef4444",
								borderRadius: 32,
								alignItems: "center",
								justifyContent: "center",
								marginBottom: 24
							},
							children: /* @__PURE__ */ jsx(Text, {
								style: {
									color: "white",
									fontSize: 32
								},
								children: "!"
							})
						}),
						/* @__PURE__ */ jsx(Text, {
							style: {
								fontSize: 20,
								fontWeight: "600",
								color: "#e8e8e8",
								marginBottom: 8,
								textAlign: "center"
							},
							children: "Something went wrong"
						}),
						/* @__PURE__ */ jsx(Text, {
							style: {
								fontSize: 14,
								color: "#888",
								textAlign: "center",
								marginBottom: 24
							},
							children: (error === null || error === void 0 ? void 0 : error.message) || "An unexpected error occurred"
						})
					]
				});
			}
			return this.props.children;
		}
	}], [{
		key: "getDerivedStateFromError",
		value: function getDerivedStateFromError(error) {
			return {
				hasError: true,
				error
			};
		}
	}]);
	return RootErrorBoundary2;
})(React.Component);
function printError(err) {
	return _instanceof(err, Error) ? `${err.message}
${err.stack}` : String(err);
}

export { RootErrorBoundary };